import { useState, useEffect } from 'react';
import axios from 'axios';
import Login from './components/Login';
import TradingDashboard from './components/TradingDashboard';

export default function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  // On load, check whether an existing session cookie is still valid.
  // If so, skip the login screen entirely.
  useEffect(() => {
    axios.get('/api/auth/me', { withCredentials: true })
      .then(res => setUser(res.data))
      .catch(() => {}) // no valid session — show login
      .finally(() => setChecking(false));
  }, []);

  const handleLogout = () => {
    axios.post('/api/auth/logout', {}, { withCredentials: true })
      .finally(() => setUser(null));
  };

  if (checking) return null; // avoid flash of login screen on page load

  if (!user) {
    return <Login onSuccess={setUser} />;
  }

  return <TradingDashboard user={user} onLogout={handleLogout} />;
}
